import React from 'react';
import {IoArrowBack} from "react-icons/io5";
import {FaAngleRight} from "react-icons/fa";
import {Tooltip} from 'react-tooltip'

const OpsBtn = ({
                    id = "",
                    btnBack = false,
                    btnText = false,
                    variant = "primary",
                    type = "button",
                    size = "",
                    backgroundColor = "bg-primary-3",
                    textColor = btnText ? "primary-3" : "color-1",
                    textStyle = "text-center",
                    textSize = "bg",
                    fontWeight = 400,
                    text = "",
                    leftIcon,
                    rightIcon,
                    icon,
                    action,
                    padding = true,
                    style,
                    rightArrow = false,
                    disabled,
                    tooltipText = "",
                    tooltipPlacement = "top"
                }) => {

    return (
        btnBack ?
            <button className={`ops-btn btn-${variant}
                                ${backgroundColor} 
                                ${textColor} 
                                btn-${size}   
                                font-${400}
                                btn-font-${textSize}                   
                                ${padding && 'p-2'} rounded-3 ms-3 mt-3`}
                    style={style}
                    type={type}
                    onClick={action}
            >
                <IoArrowBack className="ops-icon-md"/>
                <span className="ms-2">{text}</span>
            </ button>
            : btnText ?
                <h6 className={`btn-line-text px-2 ${textColor} ${textStyle}`} style={style} onClick={action}>
                    {text}
                </h6>
                :
                <>
                    <button className={`ops-btn btn-${variant} 
                                ${backgroundColor} 
                                ${textColor} 
                                btn-${size}
                                font-${fontWeight}
                                btn-font-${textSize}
                                ${disabled && 'bg-g-2 shadow-none not-allowed-cursor'}   
                                ${padding && 'p-2'} rounded-3`}
                            style={style}
                            type={type}
                            onClick={action}
                            disabled={disabled}
                            id={`btn-${id}`}
                    >
                        {leftIcon ?? leftIcon}
                        {/*{text || <img src={icon} className="ops-icon-bg m-1" alt=""/>}*/}
                        {/*{rightIcon && <img src={rightIcon} className="ops-icon-sm m-1" alt=""/>}*/}
                        {/*{leftIcon && leftIcon}*/}
                        {text || icon}
                        {rightArrow ? <FaAngleRight/> : rightIcon && rightIcon}
                    </ button>
                    {tooltipText.length > 0 &&
                        <Tooltip anchorSelect={`#btn-${id}`} place={tooltipPlacement}>{tooltipText}</Tooltip>}
                </>
    );
};

export default OpsBtn;